(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationMultipleLodgingComponentDetails',
	};

	// var $form;

	var _clearLocation,
	    _getAllInclusiveProperties,
	    _parentContainer,
	    _populateContactFields;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// $form = $(form.element);

		// Get all-inclusive properties when vendor is selected
		$('.hotel-id').on('change', function change(e) {
			var $self = $(this),
			    $con  = _parentContainer($self);

			_getAllInclusiveProperties($self.val(), $con);
		});

		// automatically adjust the check out date from the check in date once a change occurs
		$('.checkin').on('dp.change', function pickupChanged(event) {
			var startDate = event.date,
			    $con      = _parentContainer($(this)),
				endDate   = $con.find('.checkout').data('DateTimePicker');

			if (
				startDate
				&& (
					!endDate.date() ||
					(endDate && endDate.date() && endDate.date().isBefore(startDate) === true)
				)
			) {
				endDate.date(startDate.add(1, 'days'));
			}
		});

		$('.country-select').change(function countryChanged() {
			var $self  = $(this),
			    $con   = _parentContainer($self),
			    $state = $con.find('.location-state');

			if ( ($self.val() === '183') || ($self.val() === '31') ) {
				$state.empty();

				Adzuki.Ajax.get('/States/getByCountryId/' + $self.val()).then(function success(response) {
					Adzuki.Address.populateState($state, response, null);

					if ($self.data('selected-state').length > 0) {
						$state.val($self.data('selected-state'));
					}
				});

				$state.removeAttr('disabled');
			} else {
				$state.val('');
				$state.attr('disabled', 'disabled');
			}
		});

		// Set lodging name and contact info when a property is selected from all-inclusive drop-down
		$('.all-inclusive-property-id').on('change', function onPropertyIdChange(event) {
			var $self = $(this),
			    $con  = _parentContainer($self);
			_populateContactFields($(this).val(), $con);
		});

		$('.location-description').on('change', function onLocationChange(event) {
			var $con = _parentContainer($(this));
			_clearLocation($con);
		});

		Adzuki.Typeahead(
			'.location-description',
			'/Searches/hotelSearch/',
			function select(item, $self, typeahead) {
				var $con = _parentContainer($self);

				// _clearLocation($con);

				typeahead.setHiddenValue(item.id);

				if (item.giata_id) {
					$con.find('.giata-id').val(item.giata_id);

					Adzuki.Ajax.get(Adzuki.base_uri + '/HotelEngine/hotelMetaData/' + item.giata_id)
					.then(function success(response) {
						$con.find('.location-description').val(response.name);

						if (response.street_address_1) {
							$con.find('.location-address').val(response.street_address_1);
							$con.find('.location-address2').val(response.street_address_2);
							$con.find('.location-city').val(response.city);
							$con.find('.location-zip').val(response.postal_code);

							// gets the country id
							if (response.country_code) {
								Adzuki.Ajax.get('/Searches/getCountryFromCountryCode/' + response.country_code).then(function success(country) {
									var selected_state = '',
									    $country_dd    = $con.find('.country-select');

									if (response.city_state_id.length) {
										selected_state = response.city_state_id;
									}

									$country_dd.data('selected-state', selected_state);
									$country_dd.val(country.country_id).trigger('change');
								});
							}
						}
					});
				}
			},
			function template(item) {
				var html;

				if (item.city) {
					html = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else if (item.street_address_1) {
					html = item.name + ' (' + item.street_address_1 + ')';
				} else {
					html = item.name;
				}
				return html;
			}
		);
	};

	_clearLocation = function _clearLocation($container)
	{
		$container.find('.location-contact-phone, .location-address, .location-address2, .location-city, .location-state, .location-zip, .country-select').val('');
		$container.find('.country-select').trigger('change');
	};

	_getAllInclusiveProperties = function _getAllInclusiveProperties(hotel_id, $con)
	{
		var $properties = $con.find('.all-inclusive-property-id'),
		    $row        = $con.find('.all-inclusive-property-row'),
		    vendor_id,
		    property_id;

		// reset stuff
		$con.find('.location-description').val('');
		_clearLocation($con);
		$row.addClass('hidden');

		$properties.empty();
		$properties.append($('<option>').text('').attr('value', ''));

		if (hotel_id === '') {
			return;
		}

		// get vendor ID for hotel
		Adzuki.Ajax.get('/Vendors/getVendorId/lodging/hotels/' + hotel_id).then(function success(vendor) {
			vendor_id = vendor.vendor_id;

			Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + vendor_id).then(function success(properties) {
				var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

				if (sorted_properties.length > 0) {
					$.each(sorted_properties, function loadProperty(i, property) {
						$properties.append($('<option>').text(property.value).attr('value', property.key));
					});

					if (typeof $properties.data('selected-id') !== 'undefined') {
						property_id = $properties.data('selected-id');
						$properties.removeAttr('data-selected-id');
						$properties.removeData('selected-id');

						$properties.val(property_id);
					}

					$row.removeClass('hidden');
				}
			});
		});
	};

	_parentContainer = function _parentContainer($el)
	{
		return $el.parents('.address-fields');
	};

	_populateContactFields = function _populateContactFields(property_id, $con)
	{
		var $location_description   = $con.find('.location-description'),
		    $location_contact_phone = $con.find('.location-contact-phone'),
		    $location_address       = $con.find('.location-address'),
		    $location_city          = $con.find('.location-city'),
		    $country                = $con.find('.country-select');

		Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyDetails/' + property_id).then(function success(property) {
			// set lodging name
			$location_description.val(property.name);

			// set contact info
			$location_contact_phone.val(property.phone);

			$location_address.val(property.address);
			$location_city.val(property.city);

			// set country
			$country.val(property.country_id);
			$country.trigger('change');
		});
	};

}(jQuery, window.Adzuki || {}));
